namespace GeniuzPOS.PriceChange {
    export interface ActivePriceChangeForm {
        PostFg: Serenity.EnumEditor;
        ApproveBy: Serenity.StringEditor;
        Approvedate: Serenity.DateEditor;
        PluCode: Serenity.LookupEditor;
        EffectiveDate: Serenity.DateEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
    }

    export class ActivePriceChangeForm extends Serenity.PrefixedContext {
        static formKey = 'PriceChange.ActivePriceChange';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ActivePriceChangeForm.init)  {
                ActivePriceChangeForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(ActivePriceChangeForm, [
                    'PostFg', w0,
                    'ApproveBy', w1,
                    'Approvedate', w2,
                    'PluCode', w3,
                    'EffectiveDate', w2,
                    'SellUnitPrice1', w4,
                    'SellUnitPrice2', w4,
                    'SellUnitPrice3', w4,
                    'SellUnitPrice4', w4,
                    'SellUnitPrice5', w4,
                    'SellUnitPrice6', w4
                ]);
            }
        }
    }
}
